<template>
    <div class="container-fluid">
        <div class="row justify-content-between">
            <div class="col-sm-12 col-md-12">
                <div class="card dataTables_filter">
                    <div class="card-body">
                        <form class="mr-3 position-relative row">
                            <div class="form-group mx-2 col-md-5">
                                <label for="search">Search Game:</label>
                                <input type="text" id="inputSearch" class="form-control" placeholder="Game Name/ Game Code" v-model="search">
                            </div>

                            <div class="form-group mx-2 col-md-3">
                                <label for="mode">Mode</label>
                                <select id="mode" class="form-control" v-model="mode" @change="getData()">
                                    <option value="landscape" selected>Landscape</option>
                                    <option value="portrait">Portrait</option>
                                </select>
                            </div>

                            <div class="form-group mx-2 col-md-3">
                                <label for="mode">Currency</label>
                                <select id="mode" class="form-control" v-model="currency" @change="getData()">
                                    <option v-for="currency in currencyList" v-bind:key="currency.currId" :value="currency.currId">{{currency.currId}}</option>
                                </select>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" role="tablist">
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 p-2" v-for="game in filteredGames" v-bind:key="game.code">
                <a href="javascript:void(0)" :data-title="game.name" :data-url="getVideoUrl(game.code, mode, currency)" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal>
                    <b-card class="m-0">
                        <b-card-header header-tag="header" class="d-flex justify-content-center p-1 m-1">
                            <div class="header-title">
                                <h6 class="card-title">
                                    <button block class="btn btn-link text-truncate">{{game.name}}</button>
                                </h6>
                            </div>
                        </b-card-header>
                        
                        <b-card-body class="card-body p-1 m-1">
                            <!-- <b-card-img :src="require('../../../assets/images/gamepic/'+game.code+'_350x350.jpg')"></b-card-img> -->
                             <b-card-img  :src="getGameImg(game.code)"></b-card-img>
                        </b-card-body>
                    </b-card>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

const config = require("../../../../config");

export default {
    name: "ArcadeWinningVideo",
    data() {
        return {
            user: null,
            gameList: [],
            currencyList: [],
            search: '',
            mode: 'landscape',
            currency: 'USD'
        }
    },
    computed: {
        filteredGames: function() {
            const searchTerm = new RegExp(this.search, "i");
            return this.gameList.filter((game) => {
                return searchTerm.test(game.name)
                    || searchTerm.test(game.code);
            });
        }
    },
    mounted: async function() {
        this.user = localStorage.getItem("user");
        
        try { 
            this.getData();
            
            let currRes = await axios.get(config.api.URL + '/api/currency/all', { params: { m: this.$route.meta.uid } });
            this.currencyList = currRes.data;
        } catch(error) {
            alert("Error: Data retrieve error");
            console.log("Error: ", error);
        }
    },
    methods: {
        getVideoUrl(gameCode, mode, currency) {
            return 'https://demo.nextspin.com/videos/' + gameCode + '_' + mode + '_' + currency + '.mp4';
        },
        getData: async function() {
            let gameRes = await axios.get(config.api.URL + '/api/winning-video/list', {
                params: {
                    m: this.$route.meta.uid,
                    mode: this.mode,
                    currency: this.currency,
                    category: 'ARCADE'
                }
            });
            this.gameList = gameRes.data.gameList;
        },
         getGameImg(gameCode) {
            try {
                return require('../../../../static/images/gamepic/'+gameCode+'_350x350.jpg');
            } catch (error) {
                return require('../../../assets/images/NS_Black_cleaned.svg');
            }
        }
    }
}
</script>